jQuery(document).ready(function () {
  jQuery('.products_row .daily:first-child').addClass('showpro');
  jQuery(".brand_offers").click(function(){
    jQuery(this).addClass('color_background').siblings().removeClass('color_background');
    var a = jQuery(this).find('.title_col').attr('data-src');
    jQuery('.products_row .daily[data-src="'+a+'"]').addClass('showpro').siblings().removeClass('showpro');
  });
  jQuery('.custom_div').click(function() {
   jQuery(this).addClass('size_color').siblings().removeClass('size_color');
   var a = jQuery(this).find('.custom_h2').text().replace(/ /g,'');
   jQuery( ".cols.cont" ).each(function(){
      var b =  jQuery(this).attr('data-size');
     console.log(b);
       if (a == b){
           jQuery(this).show();
       }else{
           jQuery(this).hide();
       }
   });
    var a = jQuery('.daily .cols.cont[style="display: block;"]').length;
    if (a == 0){
      jQuery('.no_products').show();
    }
    else{
      jQuery('.no_products').hide();
   }
  });
  jQuery('.size_custom .custom_div:first-child').click(function() {
    jQuery(this).addClass('size_color').siblings().removeClass('size_color');
    var a = jQuery(this).find('.custom_h2').text().replace(/ /g,'');
    jQuery( ".cols.cont" ).each(function(){
      var b =  jQuery(this).attr('data-size');
      if (a == b){
        jQuery(this).show();
      }else{
        jQuery(this).show();
        jQuery('.no_products').hide();
      }
    });
    
  });
});
